import { ListboxInput, ListboxButton, ListboxList } from '@reach/listbox';
import { useField } from 'formik';
import React__default, { useCallback } from 'react';
import styled from 'styled-components';
import { setTestId } from '../../lib/testId.js';
import { useQueryChildComponents } from '../base/SystemComponent.js';
import { Chip } from '../chip/Chip.js';
import { Stack } from '../layout/Stack.js';
import { CSSGenerateTextFieldError } from '../styles/cssGenerateField.js';
import { useSelectedLabel, DEPRECATED_SelectOption, SelectPopover, SELECT_OPTION_NO_VALUE } from './DEPRECATED_commonSelect.js';
import { onChangeFieldWrapper, hasError } from './Field.js';
import { FIELD_ERROR_DATA_ATTRIBUTE, setErrorDataAttribute, FieldErrorMessage } from './FieldError.js';

/**
 * local constants
 */ const MIN_INPUT_WIDTH_REM = 13;
/**
 * Styled components
 */ const StyledListboxInput = styled(ListboxInput)`
  width: 100%;
  min-width: ${MIN_INPUT_WIDTH_REM}rem;

  [${FIELD_ERROR_DATA_ATTRIBUTE}] > & [${Chip.dataId}],
  [${FIELD_ERROR_DATA_ATTRIBUTE}] > & [${Chip.dataId}]:hover,
  [${FIELD_ERROR_DATA_ATTRIBUTE}] > & [${Chip.dataId}]:focus {
    ${CSSGenerateTextFieldError()}
  }
`;
/**
 * Chips Select Input with Formik Field bindings.
 * Accepts `SelectOptions` as child components. If a 'deselected' option is required, it
 * must be manually added to options.
 * Also accepts an optional `Avatar` component as a child - this is if you want to replace the
 * 'standard' chip icon with an Avatar.
 *
 * @example
 * <SelectField name="chicken">
 *  <SelectOption label="" value={SELECT_OPTION_NO_VALUE} />
 *  <SelectOption label="Egg" value="egg" />
 *  <SelectOption label="Duck" value="duck" />
 * </SelectField>
 *
 * // with Avatar
 * <SelectField name="chicken">
 *  <Avatar initials="FF" />
 *  <SelectOption label="" value={SELECT_OPTION_NO_VALUE} />
 *  <SelectOption label="Egg" value="egg" />
 *  <SelectOption label="Duck" value="duck" />
 * </SelectField>
 */ const DEPRECATED_ChipSelectField = ({ name , icon , label , isHighlighted , placeholder , children , testId ="X" , reserveMessageSpace =true , onFieldChange , ...props })=>{
    const [field, meta, helpers] = useField(name);
    const { setValue , setTouched  } = helpers;
    // store current selected option data
    const selectedLabel = useSelectedLabel(children, field);
    // wrap the on change to perform side effects if needed
    const onChange = useCallback((value)=>{
        const updatedValue = value === SELECT_OPTION_NO_VALUE ? "" : value;
        !!onFieldChange ? onChangeFieldWrapper(onFieldChange, setValue)(updatedValue) : setValue(updatedValue);
    }, [
        onFieldChange,
        setValue
    ]);
    const [listboxChildren, otherChildren] = useQueryChildComponents(children, [
        DEPRECATED_SelectOption
    ]);
    return React__default.createElement(Stack, {
        "data-hpy-web-select-field": true,
        gap: 0.25,
        ...setErrorDataAttribute(hasError(meta))
    }, React__default.createElement(StyledListboxInput, {
        "data-hpy-web-select-field-input": true,
        ...setTestId("ChipSelectField-" + testId),
        ...props,
        value: field.value,
        portal: true,
        onChange: onChange
    }, React__default.createElement(ListboxButton, {
        as: Chip,
        testId: "ChipSelectField-" + testId,
        icon: icon,
        label: label,
        readOnly: props.readOnly,
        sublabel: selectedLabel || placeholder,
        isHighlighted: isHighlighted,
        onClick: ()=>setTouched(true)
    }, otherChildren), React__default.createElement(SelectPopover, null, React__default.createElement(ListboxList, {
        "data-hpy-web-select-field-listbox-list": true
    }, listboxChildren))), React__default.createElement(FieldErrorMessage, {
        name: name,
        reserveMessageSpace: reserveMessageSpace
    }));
};
DEPRECATED_ChipSelectField.dataId = "data-hpy-web-select-field";
DEPRECATED_ChipSelectField.displayName = "ChipSelectField";

export { DEPRECATED_ChipSelectField };
